import axios from 'axios';

import { AudienceGroup, AudienceGroupOption } from '../../types/domainModels';
import { getAPIUrl } from './baseAPI';

export const GET_AUDIENCE_GROUPS = () => ({
  path: `/audienceGroup`,
  version: 'v2' as const,
});

export async function getAudienceGroups() {
  return (await axios.get<AudienceGroup[]>(getAPIUrl(GET_AUDIENCE_GROUPS())))
    .data;
}

export const GET_AUDIENCE_GROUP = ({
  audienceGroupId,
}: {
  audienceGroupId: number;
}) => ({
  path: `/audienceGroup/${audienceGroupId}`,
  version: 'v2' as const,
});

export async function getAudienceGroup({
  audienceGroupId,
}: {
  audienceGroupId: number;
}) {
  return (
    await axios.get<AudienceGroup>(
      getAPIUrl(GET_AUDIENCE_GROUP({ audienceGroupId })),
    )
  ).data;
}

export const GET_AUDIENCE_GROUP_OPTIONS = ({
  audienceGroupId,
}: {
  audienceGroupId: number;
}) => ({
  path: `/audienceGroup/${audienceGroupId}/options`,
  version: 'v2' as const,
});

export async function getAudienceGroupOptions({
  audienceGroupId,
}: {
  audienceGroupId: number;
}) {
  return (
    await axios.get<AudienceGroupOption[]>(
      getAPIUrl(GET_AUDIENCE_GROUP_OPTIONS({ audienceGroupId })),
    )
  ).data;
}
